//Some environment settings
import {getMeasurementId} from "Helpers";

const MORPHEUS = window.MORPHEUS;
const {enviroment: environment} = MORPHEUS;

//Placing it here for now
const BRAND_CONFIG = MORPHEUS.core.brandConfig;
const BRAND_FEATURES = BRAND_CONFIG.features;

export const GEO_IP_COUNTRY_CODE = environment.geoIp ?? "";
export const IS_MOBILE = environment.isMobile;
export const IS_DEV = window?.reactDev ?? false;
export const IS_QA3 = environment.isStaging && !BRAND_CONFIG?.morpheus?.temp?.stagingJsVersion;
export const IS_PRE_PROD = environment.isStaging && BRAND_CONFIG?.morpheus?.temp?.stagingJsVersion;
export const IS_STAGING = environment.isStaging;
export const IS_PROD = !IS_STAGING;

export const LOG_ENVIRONMENT = IS_DEV ? 'local' : IS_QA3 ? 'qa3' : IS_PRE_PROD ? 'staging' : 'production';

export const IS_HOT_RELOAD_ENABLED = IS_DEV && window.hot ? window.hot : false;
export const HOT_RELOAD_PATH = "https://localhost:9001";

export const IS_LOGGED_IN = environment.isLoggedIn;
export const CAN_LOGIN = MORPHEUS?.core?.extended?.lf ?? true;
export const CAN_REGISTER = MORPHEUS?.core?.extended?.sf ?? true;
export const STORED_USERNAME = MORPHEUS?.core?.username ?? '';
export const PLAYER_ID = MORPHEUS?.core?.playerId ?? false;

const BINGO_BRANDS = ["bb", "db", "gb", "rb", "bd"];
export const MULTI_TIME_BINGO_ROOMS = BRAND_FEATURES?.bingoRooms?.multiTimeRooms ?? false;

//  Risk Scores
export const RISK_CATEGORY_TRIGGERS = ["medium"];
export const RISK_RATING_TRIGGERS = [5, 6, 9];
export const RISK_CATEGORY = MORPHEUS?.account?.riskCategory ?? "";
export const RISK_RATING = MORPHEUS?.account?.riskRating ?? 0;
export const RISK_STATUS_ON_MODAL_TRIGGERED_CLAIM_NAME = "RiskStatusOnModalTriggered";

export let IS_GOOGLE_BOT = false;
if (window?.navigator?.userAgent) {
    const knownBots = ["googlebot, lighthouse"];
    const ua = window.navigator.userAgent;

    knownBots.forEach(bot => {
        if (ua.toLowerCase().indexOf(bot) >= 0) {
            IS_GOOGLE_BOT = true;
        }
    })
}

// if (IS_DEV && IS_LOGGED_IN) {
//     MORPHEUS.bootEnvironment = {
//         ftdPlayer: false,
//         justLoggedIn: true,
//         // promoCode: "Test_Sig_Terms",
//         showWelcomeLightbox: true
//     }
// }

// WELCOME LIGHTBOX
const BOOT_ENVIRONMENT = MORPHEUS?.bootEnvironment ?? null;
export const FTD_PLAYER = BOOT_ENVIRONMENT?.ftdPlayer ?? false;
export const JUST_LOGGED_IN = BOOT_ENVIRONMENT?.justLoggedIn ?? false;
export const WELCOME_LIGHTBOX_PROMOCODE = BOOT_ENVIRONMENT?.promoCode ?? false;
export const SHOW_WELCOME_LIGHTBOX = BOOT_ENVIRONMENT?.showWelcomeLightbox ?? false;
export const IS_LOGIN_LIGHTBOX_ENABLED = IS_LOGGED_IN && true && WELCOME_LIGHTBOX_PROMOCODE;

// Returning Player Lightbox Settings
export const IS_RETURNING_PLAYER_LIGHTBOX_ENABLED = true;
export const RETURNING_PLAYER_LIGHTBOX_CLAIM_NAME = "ReturningPlayerLightboxLastShownDate";

const NDL_SETTINGS = BRAND_FEATURES?.netDepositLimits ?? null;
const DUMMY_CLAIM_NAME = "UNKNOWNCLAIM123";

export const IS_RESPONSIBLE_GAMING_APP_ENABLED = true;
export const IS_NET_DEPOSIT_LIMITS_ENABLED = NDL_SETTINGS?.enabled ?? false;
export const IS_SWITCH_TO_NET_DEPOSIT_LIMITS_ACCOUNT_WIDGET_ENABLED = NDL_SETTINGS?.accountWidget?.enabled ?? false;
export const NDL_ACCOUNT_WIDGET_TITLE = NDL_SETTINGS?.accountWidget?.title ?? "title";
export const NDL_ACCOUNT_WIDGET_MESSAGE = NDL_SETTINGS?.accountWidget?.message ?? "message";
export const SHOW_SWITCH_TO_NET_DEPOSIT_LIMITS_MODAL = NDL_SETTINGS?.modal?.enabled ?? false;
export const SWITCH_TO_NDL_MODAL_CONTENT = NDL_SETTINGS?.modal?.content ?? {};
export const NDL_MODAL_MAX_REJECTIONS = NDL_SETTINGS?.modal?.maxRejections ?? 3;
export const NDL_MODAL_DAYS_UNTIL_NEXT_PROMPT = NDL_SETTINGS?.modal?.daysUntilPromptAfterRejection ?? 7;
export const HIDE_DEPOSIT_LIMITS_IF_NO_LIMIT_EXISTS = NDL_SETTINGS?.hideDLIfNoLimitsSet ?? false;
export const SHOW_MODAL_ONCE_PER_SESSION_UNTIL_REJECTED = NDL_SETTINGS?.modal?.showOncePerSessionUntilRejected ?? false;
export const IS_DELAY_ON_NDL_OPT_OUT_ENABLED = NDL_SETTINGS?.modal?.delayOnOptOutEnabled ?? false;
export const DELAY_ON_NDL_OPT_OUT_MS = NDL_SETTINGS?.modal?.delayOnOptOutMs ?? 5000;
export const NDL_MODAL_EXPLICITLY_SHOW_ON_DAY_OF_THE_WEEK = NDL_SETTINGS?.modal?.explicitlyShowOnDayOfWeek ?? true;
export const NDL_MODAL_SHOW_ON_DAY_OF_THE_WEEK_INDEX = NDL_SETTINGS?.modal?.showOnDayIndex ?? 1;

export const DEPOSIT_LIMIT_ID = 'depositLimit';
export const NET_DEPOSIT_LIMIT_ID = 'netDepositLimit';

// COMMON LABELS
export const LABEL_DEPOSIT_LIMIT = "Deposit Limit";
export const LABEL_NET_DEPOSIT_LIMIT = "Net Deposit Limit";

export const SERVE_WEBP_IMAGES = true;

export const APP_VERSION = BRAND_CONFIG?.morpheus?.temp?.jsVersion ?? 'N/A';
export const BRAND_NAME = BRAND_CONFIG.brandName;
export const BRAND_THEME = BRAND_CONFIG.brandTheme;
export const BRAND_SUPPORT_EMAIL = BRAND_CONFIG.supportEmail;
export const APP_CDN_PATH = BRAND_CONFIG.appCdnUrl;
export const CDN_PATH = BRAND_CONFIG.cdnUrl;
export const CDN_BRAND_PATH = BRAND_CONFIG.cdnBrandPath;

//BANKING SETTINGS
export const IS_QUICK_BANKING_ENABLED = true;
export const IS_SLIM_BANKING_ENABLED = true;
export const DEBIT_CARD_DEPOSIT_MESSAGE = "Only debit card deposits are eligible for bonuses";
export const SHOW_DEBIT_CARD_DEPOSIT_MESSAGE = true;
export const USE_NEW_BANKING_EVENT_LISTENER = true;
export const SHOW_DL_PROGRESS_ON_DEPOSIT_SCREEN = BRAND_FEATURES?.banking?.showLimitProgress ?? false;

export const IS_APPLE_PAY_ENABLED = BRAND_CONFIG?.features?.applePay?.enabled ?? false;

export const USE_NEW_CDN = !!BRAND_FEATURES?.imageCdn?.useNewCdn;
export const OLD_SHARED_CDN_PATH = 'https://images.broadwaygaming.com';
export const NEW_SHARED_CDN_PATH = 'https://images2.broadwaygaming.com/content';
export const SHARED_CDN_PATH = USE_NEW_CDN ? NEW_SHARED_CDN_PATH : OLD_SHARED_CDN_PATH;
export const SHARED_CDN_BRAND_ID = BRAND_CONFIG.sharedImagesId;

export const IMAGES_PATH = `${NEW_SHARED_CDN_PATH}/Morpheus/${CDN_BRAND_PATH}`;
export const SHARED_IMAGES_PATH = `${NEW_SHARED_CDN_PATH}/Morpheus/shared`;

export const IS_AVATARS_ENABLED = BRAND_FEATURES?.avatars?.enabled ?? false;
export const AVATAR_IMAGES_PATH = `${NEW_SHARED_CDN_PATH}/Avatars`;

//IMAGE PATH CONSTANTS
export const BINGO_ROOMS_IMAGES = `${SHARED_CDN_PATH}/BingoRooms/${SHARED_CDN_BRAND_ID}`;
export const BINGO_ROOMS_SHARED_IMAGES = `${SHARED_CDN_PATH}/BingoRooms/Shared`;
export const SPIN_THE_WHEEL_IMAGES_PATH = `${SHARED_CDN_PATH}/Promotions/Shared/SpinTheWheel`;
export const SVG_URL = `${SHARED_IMAGES_PATH}/svg/`;

export const CASINO_ICON_PATH = `${SHARED_CDN_PATH}/CasinoIcons`;
export const CASINO_ICON_SIZE_DIRECTORIES = ['horizontal', 'vertical', 'large'];
export const ALLOW_RETINA_CASINO_ICONS = false;

//REGISTRATION
export const IS_OCCUPATION_FIELD_ENABLED = BRAND_FEATURES?.registration?.occupation?.enabled ?? true;
export const IS_NATIONALITY_FIELD_ENABLED = true;
export const MARKETING_PREFERENCES_V2 = BRAND_CONFIG?.marketingPreference ?? null;
export const MARKETING_PREFERENCES_V2_ENABLED = MARKETING_PREFERENCES_V2?.enabled ?? false;
export const MARKETING_PREFERENCES_OPTIONS = MARKETING_PREFERENCES_V2?.options ?? null;
export const MARKETING_PREFERENCES_PRODUCTS = MARKETING_PREFERENCES_OPTIONS?.products ?? [];
export const MARKETING_PREFERENCES_CHANNELS = MARKETING_PREFERENCES_OPTIONS?.channels ?? [];
export const MARKETING_PREFERENCES_CLAIM_NAME = "DirectMarketingMigrated";

export const NEW_MARKETING_PREFERENCES_DEFAULT_REG_CONFIG = MARKETING_PREFERENCES_V2?.comms?.regpage ?? null;
export const NEW_MARKETING_PREFERENCES_DEFAULT_MODAL_CONFIG = MARKETING_PREFERENCES_V2?.comms?.login ?? null;
export const NEW_MARKETING_PREFERENCES_MASTER_TOGGLE_MESSAGE = NEW_MARKETING_PREFERENCES_DEFAULT_REG_CONFIG?.masterToggleText.replaceAll('{{BRAND_NAME}}', BRAND_NAME);

// FEATURES
const UNIX_NOW = Math.floor(Date.now() / 1000);
export const REWARDS_ENABLED = BRAND_FEATURES?.rewards?.enabled ?? false;
export const REWARDS_SCHEME_NAME = BRAND_FEATURES?.rewards?.schemeName ?? "Rewards";
export const BINGO_ENABLED = BINGO_BRANDS.includes(BRAND_THEME);
export const ANIMATED_BINGO_CARD_ENABLED = !IS_MOBILE;
export const ANIMATED_GAME_ICONS_ENABLED = !IS_MOBILE;
export const ACTIVATED_GAME_ICONS_ENABLED = true;
export const DISPLAY_NET_POSITION_AND_SESSION = false;
export const SHOW_PJP_ON_BINGO_CARDS = true;
export const PICK_YOUR_BONUS_ENABLED = IS_LOGGED_IN;
export const SPIN_THE_WHEEL_ENABLED = (IS_LOGGED_IN && BRAND_FEATURES?.spinTheWheel?.enabled) ?? false;
export const IS_CAMPAIGN_MANAGER_PUSH_NOTIFICATIONS_ENABLED = true;
export const IS_FREE_SPINS_ENABLED = BRAND_FEATURES?.freeSpins?.enabled ?? false;
export const IS_GAME_STUDIO_FREE_SPINS_ENABLED = BRAND_FEATURES?.freeSpins?.gameStudio?.enabled ?? !IS_PROD;
export const MGS_FREE_SPINS_CONFIG = BRAND_FEATURES?.freeSpins?.mgs ?? [];
export const DAILY_DEAL_VERSION = BRAND_FEATURES?.dailyDeal?.version ?? 1;
export const IS_DOCUMENT_UPLOAD_ENABLED = BRAND_FEATURES?.documentUpload?.enabled ?? false;
export const IS_FINANCIAL_LIMIT_LINKS_ENABLED = true;
export const FINANCIAL_LIMITS_REDIRECT_URL = `/responsible-gambling-app/net-deposit-limits`;
export const USE_WEBSOCKET_MANAGER_V2 = BRAND_FEATURES?.websockets?.v2Enabled ?? false;
// export const SHOW_PROTECTION_OF_FUNDS_ON_FTD_SCREEN = BRAND_FEATURES?.banking?.showProtectionfOfFunds ?? true;
export const SHOW_PROTECTION_OF_FUNDS_ON_FTD_SCREEN = true;
export const NUMBER_OF_PROMOTIONS_TO_REQUEST = BRAND_FEATURES?.promotions?.take ?? 200;
export const WHITELISTED_PLAYER_IDS = BRAND_FEATURES?.bingoSideGameFeature?.whitelist ?? [];
export const IS_BINGO_SIDE_GAME_FEATURE_ENABLED = BRAND_FEATURES?.bingoSideGameFeature?.enabled || (IS_LOGGED_IN && WHITELISTED_PLAYER_IDS.includes(PLAYER_ID)) || !IS_PROD;

export const IS_WINNERS_FEED_ENABLED = BRAND_FEATURES?.winnersFeed?.enabled ?? !IS_PROD;
export const IS_WINNERS_FEED_ENABLED_FOR_LOGGED_OUT = BRAND_FEATURES?.winnersFeed?.enabledLoggedOut ?? !IS_PROD;
export const WINNERS_FEED_LIMIT = 25;
export const WINNERS_FEED_REFRESH_INTERVAL = BRAND_FEATURES?.winnersFeed?.interval ?? 1000 * 60 * 10;
export const WINNERS_FEED_SPEED = BRAND_FEATURES?.winnersFeed?.speed ?? 50;
export const WINNERS_FEED_GRADIENT_ENABLED = BRAND_FEATURES?.winnersFeed?.gradient ?? true;

export const IS_EXIT_POPUP_ENABLED = BRAND_FEATURES?.exitPopup?.enabled ?? false;
export const EXIT_POPUP_MAX_CONSECUTIVE_DISMISSALS = BRAND_FEATURES?.exitPopup?.maxDismissals ?? 2;
export const EXIT_POPUP_MAX_GAMES_TO_SHOW_IN_MODAL = BRAND_FEATURES?.exitPopup?.maxGamesToShow ?? 3;
export const EXIT_POPUP_EXIT_GAME_MODAL_TITLE = BRAND_FEATURES?.exitPopup?.title ?? "You May Also Like...";

// SG WEEK

const SGW_SETTINGS = BRAND_FEATURES?.saferGamblingWeek ?? {};
const START_SG_WEEK_COPY = SGW_SETTINGS?.startDate ?? null;
const END_SG_WEEK_COPY = SGW_SETTINGS?.endDate ?? null;
const START_SG_WEEK_COPY_DATE = START_SG_WEEK_COPY ? new Date(START_SG_WEEK_COPY) : null;
const END_SG_WEEK_COPY_DATE = END_SG_WEEK_COPY ? new Date(END_SG_WEEK_COPY) : null;

export const SG_WEEK_DATES_STRING = (START_SG_WEEK_COPY_DATE && END_SG_WEEK_COPY_DATE) ? `${START_SG_WEEK_COPY_DATE.getDate()} - ${END_SG_WEEK_COPY_DATE.getDate()} ${END_SG_WEEK_COPY_DATE.toLocaleString('default', {month: 'long'})} ${END_SG_WEEK_COPY_DATE.getFullYear()}` : "";

const START_SG_WEEK_VISIBILITY = SGW_SETTINGS?.visibilityStartDate ?? null;
const END_SG_WEEK_VISIBILITY = SGW_SETTINGS?.visibilityEndDate ?? null;
const START_SG_WEEK_VISIBILITY_TIMESTAMP = START_SG_WEEK_VISIBILITY ? Math.floor(new Date(START_SG_WEEK_VISIBILITY) / 1000) : null;
const END_SG_WEEK_VISIBILITY_TIMESTAMP = END_SG_WEEK_VISIBILITY ? Math.floor(new Date(END_SG_WEEK_VISIBILITY) / 1000) : null;

export const SG_WEEK_ENABLED = (START_SG_WEEK_VISIBILITY_TIMESTAMP && END_SG_WEEK_VISIBILITY_TIMESTAMP) ? (UNIX_NOW >= START_SG_WEEK_VISIBILITY_TIMESTAMP && UNIX_NOW <= END_SG_WEEK_VISIBILITY_TIMESTAMP) : false;

const PTR_BRANDS = ["gb"];
export const NEW_PTR_ENABLED = BRAND_FEATURES?.newPtrChangesEnabled ?? PTR_BRANDS.includes(BRAND_THEME);
export const CAN_REDIRECT_ON_LOGIN = BRAND_FEATURES?.redirectOnLogin ?? true;

export const DF_ROOMS_ROOM_SETTINGS = BRAND_FEATURES?.bingoRooms?.dfRoomSettings ?? [];
export const IS_DF_BINGO_ENABLED = (BRAND_FEATURES?.bingoRooms?.isDFRoomsEnabled && DF_ROOMS_ROOM_SETTINGS.length > 0) ?? false;
export const USE_DRAGONFISH_BINGO_FEED = IS_DF_BINGO_ENABLED;

export const MAX_GAMES_IN_RECENTLY_PLAYED = 9;
// export const MAX_GAMES_IN_FAVOURITES = 16;
export const USER_PREFERRED_GAMES_TAB_ENABLED = true && IS_LOGGED_IN;
export const IS_FAVOURITE_GAMES_ENABLED = false && IS_LOGGED_IN;

const START_SPECIAL_EVENT = Math.floor(new Date('11/25/2024 00:00') / 1000);
const END_SPECIAL_EVENT = Math.floor(new Date('12/01/2024 23:59') / 1000);

export const SPECIAL_EVENT_PROMO_ENABLED = IS_LOGGED_IN && !["cf"].includes(BRAND_THEME) && (IS_STAGING || (UNIX_NOW > START_SPECIAL_EVENT && UNIX_NOW < END_SPECIAL_EVENT));
export const SPECIAL_EVENT_PROMO_NAME = "Black Friday";
export const SPECIAL_EVENT_PROMO_MASTERGROUP = "BLACKFRIDAY24_NOV_MASTERGROUP";
export const SPECIAL_EVENT_PROMO_PREFIX = "BLACKFRIDAY24_NOV_DAY";
export const SPECIAL_EVENT_PROMO_URL = "/black-friday";
export const SPECIAL_EVENT_PROMO_CLASS = "black-friday";

const START_OUTAGE = Math.floor(new Date('11/29/2023 05:00') / 1000);
const END_OUTAGE = Math.floor(new Date('11/29/2023 07:00') / 1000);
const IS_OUTAGE = (UNIX_NOW > START_OUTAGE && UNIX_NOW < END_OUTAGE);

export const PROMOS_ENABLED = true;
export const DISABLED_GAME_PROVIDERS = (IS_LOGGED_IN && IS_OUTAGE) ? ["PragmaticBingo"] : [];
export const BINGO_MAINTENANCE = DISABLED_GAME_PROVIDERS.includes("PragmaticBingo");

export const SERVICE_ANNOUNCEMENT_ENABLED = IS_OUTAGE;
export const SERVICE_ANNOUNCEMENT_MESSAGE = "Maintenance is currently being carried out on some games until 7am. The Bingo Rooms are closed for now, please enjoy slot games in the meantime or pop back after 7am, when the rooms will be available again.";

export const BINGO_SERVICE_ANNOUNCEMENT_ENABLED = IS_OUTAGE && BINGO_MAINTENANCE;
export const BINGO_SERVICE_ANNOUNCEMENT_MESSAGE = "Maintenance is currently being carried out on some games until 7am. The Bingo Rooms are closed for now, please enjoy slot games in the meantime or pop back after 7am, when the rooms will be available again.";

export const LOAD_ACCOUNT_VERIFICATION_PAGES_FROM_FORGE = true;

// BINGO
export const LOAD_MINI_GAMES_FROM_MORPHEUS = true;

// CUSTOM SKINS
const SKINS_UNIX_NOW = Math.floor(Date.now() / 1000);
const SKINS_START_DATE = Math.floor(new Date('12/15/2025 00:00') / 1000);
const SKINS_END_DATE = Math.floor(new Date('01/02/2026 00:00') / 1000);
const SKINS_IS_ENABLED = (SKINS_UNIX_NOW > SKINS_START_DATE && SKINS_UNIX_NOW < SKINS_END_DATE);
export const CUSTOM_SITE_SKIN_ENABLED = SKINS_IS_ENABLED;
export const CUSTOM_SITE_SKIN_NAME = "xmas-2022";

// LANDING PAGE SETTINGS
const LANDING_PAGE_SETTINGS = BRAND_CONFIG.landingPages;
export const LANDING_PAGES_ENABLED = (LANDING_PAGE_SETTINGS?.landingPagesEnabled ?? false) && CAN_REGISTER;
export const NEW_PLAYER_HOMEPAGE_ENABLED = (LANDING_PAGE_SETTINGS?.newPlayerHomepageEnabled ?? false) && CAN_REGISTER;
export const DEFAULT_LANDING_PAGE_ROUTE = LANDING_PAGE_SETTINGS?.defaultLandingPage ?? "/";
export const REDIRECT_ALL_LANDING_PAGES_TO_DEFAULT = LANDING_PAGES_ENABLED ? LANDING_PAGE_SETTINGS?.redirectAllToDefault ?? false : false;
export const REDIRECT_MISSING_LANDING_PAGES_TO_HOMEPAGE = LANDING_PAGE_SETTINGS?.redirectNonExistentLPsToHomepage ?? false;

export const IS_WELCOME_BONUS_CHECKED_BY_DEFAULT = false;
export const IS_GDPR_CHECKED_BY_DEFAULT = !MARKETING_PREFERENCES_V2_ENABLED;

// MAINTENANCE MODE
export const IS_BRAND_IN_MAINTENANCE_MODE = BRAND_CONFIG?.maintenanceMode?.brand ?? false;

// EXTERNAL SERVICES
const BRAND_EXTERNAL_SERVICES = BRAND_CONFIG.externalServices;
export const IS_SENTRY_ENABLED = IS_DEV ? false : BRAND_EXTERNAL_SERVICES?.sentry?.enabled ?? false;
export const IS_SENTRY_REPLAYS_ENABLED = BRAND_EXTERNAL_SERVICES?.sentry?.replaysEnabled ?? false;
export const SENTRY_REPLAYS_SAMPLE_RATE = BRAND_EXTERNAL_SERVICES?.sentry?.replaysSampleRate ?? IS_PROD ? 0.1 : 1.0;
export const ZENDESK_CHAT_ENABLED = BRAND_EXTERNAL_SERVICES.zendesk.chat.enabled ?? false;
export const ZENDESK_SCRIPT_URL = BRAND_EXTERNAL_SERVICES.zendesk.chat.externalCodeURL;
export const ZENDESK_API_VERSION = BRAND_EXTERNAL_SERVICES.zendesk.chat.version ?? "v1";
export const HELP_CENTER_ENABLED = BRAND_EXTERNAL_SERVICES.zendesk.helpCenter.enabled ?? false;
export const HELP_CENTER_URL = BRAND_EXTERNAL_SERVICES.zendesk.helpCenter.helpCenterURL;
export const TRUSTPILOT_ENABLED = BRAND_EXTERNAL_SERVICES.trustPilot.enabled ?? false;
export const TRUSTPILOT_SETTINGS = {
    templateId: BRAND_EXTERNAL_SERVICES.trustPilot.templateId ?? false,
    businessUnitId: BRAND_EXTERNAL_SERVICES.trustPilot.businessUnitId ?? false,
    theme: BRAND_EXTERNAL_SERVICES.trustPilot.theme ?? false
};


export const IS_SNAPCHAT_TRACKING_ENABLED = BRAND_EXTERNAL_SERVICES?.tracking?.snapchat?.enabled ?? false;
export const SNAPCHAT_TRACKING_PIXEL_ID = BRAND_EXTERNAL_SERVICES?.tracking?.snapchat?.pixelId ?? null;

export const IS_MICROSOFT_TRACKING_ENABLED = BRAND_EXTERNAL_SERVICES?.tracking?.microsoft?.enabled ?? false;
export const MICROSOFT_TRACKING_PIXEL_ID = BRAND_EXTERNAL_SERVICES?.tracking?.microsoft?.pixelId ?? null;

// export const GA_ENABLED = false;
// export const GA_ID = getGASiteId();
export const GTM_ENABLED = BRAND_EXTERNAL_SERVICES.google.gtm.enabled ?? false;
// export const GTM_ID = GTM_ENABLED ? BRAND_EXTERNAL_SERVICES.google.gtm.id : false;
export const GA4_ENABLED = true;
export const GA4_ID = getMeasurementId();
// export const SEND_PLAYER_ID_AS_CUSTOM_DIMENSION = true;
export const SEND_DATA_TO_S2S_FB_PIXEL = [...BINGO_BRANDS, "cd"].includes(BRAND_THEME);
export const SEND_CONSENT_VALUE_IN_REGISTRATION_PAYLOAD = BRAND_EXTERNAL_SERVICES?.google?.sendConsentInRegistration ?? false;

// LICENSE DETAILS
const BRAND_LICENSE_DETAILS = BRAND_CONFIG.licenseDetails;
export const UKGC_LICENSE_NUMBER = BRAND_LICENSE_DETAILS.ukgcLicenseNumber;
export const UKGC_LICENSE_URL = BRAND_LICENSE_DETAILS.ukgcLicenseURL;

// REGULATED
const REGULATED = BRAND_CONFIG.regulated;
export const BONUS_MONEY_RULES_STRAPLINE = REGULATED.bonusMoneyRulesStrapline;
export const BONUS_MONEY_RULES_STRAPLINE_NEW_PLAYER = REGULATED.bonusMoneyRulesStraplineNewPlayer;
export const BONUS_MONEY_RULES_STRAPLINE_LANDING_PAGE = REGULATED.bonusMoneyRulesStraplineLandingPage;
export const FB_TERMS_ENABLED = !["cf"].includes(BRAND_THEME);

// Not allowed view any content, show full block message on all pages.
const GEO_BLOCKED_COUNTRY_LIST = ["CA"];
export const IS_CLIENT_FROM_GEO_BLOCKED_COUNTRY = GEO_BLOCKED_COUNTRY_LIST.includes(GEO_IP_COUNTRY_CODE.toUpperCase());
export const RESTRICTED_COUNTRY_ROUTE = "/restricted-country";

// User stuff
export const COOKIE_BANNER_ENABLED = !BRAND_EXTERNAL_SERVICES?.onetrust?.enabled ?? true;
export const HAS_ACCEPTED_COOKIES = !MORPHEUS.core.cookieBanner || IS_LOGGED_IN;

// Check for messages under the category 'Verification' on login?
export const VERIFICATION_MESSAGE_MODAL_ENABLED = JUST_LOGGED_IN && (BRAND_FEATURES?.checkforVerificationMessagesOnLogin ?? false);
export const VERIFICATION_MESSAGE_MODAL_CATEGORY = IS_STAGING ? "Important" : "Verification";

//Dev Stuff
export const IS_THEME_SWITCHER_ENABLED = IS_DEV && true;

function canUseWebP() {
    try {
        var elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
    } catch (e) {
        return false;
    }

    // very old browser like IE 8, canvas not supported
    return false;
}

export const SUPPORTS_WEBP = canUseWebP();


// Gambit Games Settings
const GAMBIT_GAMES = BRAND_FEATURES?.gambitGames ?? {};
export const IS_GAMBIT_GAMES_ENABLED = GAMBIT_GAMES?.enabled ?? false;

const MASTERGROUP_NOT_SET_PREFIX = "NOT_SET_";
const PRIZEGROUP_NOT_SET_PREFIX = "NO_PRIZE";

const MATCH_THREE_SETTINGS = GAMBIT_GAMES?.matchThree ?? {};
export const IS_MATCH_THREE_ENABLED = (IS_GAMBIT_GAMES_ENABLED && MATCH_THREE_SETTINGS?.enabled) ?? false;
export const MATCH_THREE_MASTERGROUP = MATCH_THREE_SETTINGS?.mastergroupPrefix ?? MASTERGROUP_NOT_SET_PREFIX;
export const MATCH_THREE_PRIZE_PREFIX = MATCH_THREE_SETTINGS?.prizePrefix ?? PRIZEGROUP_NOT_SET_PREFIX;
export const GAMBIT_MATCH_THREE_MODAL_ID = "GambitMatchThreeCards";

const DOUBLE_WHEEL_SETTINGS = GAMBIT_GAMES?.doubleWheel ?? {};
export const IS_DOUBLE_WHEEL_ENABLED = (IS_GAMBIT_GAMES_ENABLED && DOUBLE_WHEEL_SETTINGS?.enabled) ?? false;
export const DOUBLE_WHEEL_MASTERGROUP = DOUBLE_WHEEL_SETTINGS?.mastergroupPrefix ?? MASTERGROUP_NOT_SET_PREFIX;
export const DOUBLE_WHEEL_PRIZE_PREFIX = DOUBLE_WHEEL_SETTINGS?.prizePrefix ?? PRIZEGROUP_NOT_SET_PREFIX;
export const GAMBIT_DOUBLE_WHEEL_MODAL_ID = "GambitDoubleWheel";

const SINGLE_WHEEL_SETTINGS = GAMBIT_GAMES?.singleWheel ?? {};
export const IS_SINGLE_WHEEL_ENABLED = (IS_GAMBIT_GAMES_ENABLED && SINGLE_WHEEL_SETTINGS?.enabled) ?? false;
export const SINGLE_WHEEL_MASTERGROUP = SINGLE_WHEEL_SETTINGS?.mastergroupPrefix ?? MASTERGROUP_NOT_SET_PREFIX;
export const SINGLE_WHEEL_PRIZE_PREFIX = SINGLE_WHEEL_SETTINGS?.prizePrefix ?? PRIZEGROUP_NOT_SET_PREFIX;
export const GAMBIT_SINGLE_WHEEL_MODAL_ID = "GambitSingleWheel";

const PENALTY_SHOOTOUT_SETTINGS = GAMBIT_GAMES?.penaltyShootout ?? {};
export const IS_PENALTY_SHOOTOUT_ENABLED = (IS_GAMBIT_GAMES_ENABLED && PENALTY_SHOOTOUT_SETTINGS?.enabled) ?? false;
export const PENALTY_SHOOTOUT_MASTERGROUP = PENALTY_SHOOTOUT_SETTINGS?.mastergroupPrefix ?? MASTERGROUP_NOT_SET_PREFIX;
export const PENALTY_SHOOTOUT_PRIZE_PREFIX = PENALTY_SHOOTOUT_SETTINGS?.prizePrefix ?? PRIZEGROUP_NOT_SET_PREFIX;
export const GAMBIT_PENALTY_SHOOTOUT_MODAL_ID = "GambitPenaltyShootout";